import { EFinancingProgram } from '@if/core/types'
import FollowUpAgentBadge from '@src/containers/ViewCreditApplicationPage/components/FollowUpAgentBadge'

interface FollowUpAgent {
  id: string
  firstName: string
  lastName: string
  initials: string
}

interface FollowUpAgentCellProps {
  followUpAgent?: FollowUpAgent | null
  creditApplicationId?: string
  financingProgramId?: EFinancingProgram
  currentFilters?: Record<string, string | number | string[] | number[]>
}

/**
 * Presentational component that displays the Follow-Up Agent badge.
 * If creditApplicationId and related props are provided, the badge will be editable.
 * Otherwise, it will be read-only.
 */
const FollowUpAgentCell = ({
  followUpAgent,
  creditApplicationId,
  financingProgramId,
  currentFilters,
}: FollowUpAgentCellProps) => {
  if (!creditApplicationId || !financingProgramId) {
    return null
  }

  return (
    <FollowUpAgentBadge
      followUpAgent={followUpAgent}
      creditApplicationId={creditApplicationId}
      financingProgramId={financingProgramId}
      currentFilters={currentFilters}
    />
  )
}

export default FollowUpAgentCell